export const ReportFormat = {
    Json: "Json",
    Pdf: "Pdf",
    Excel: "Excel",
};
